<script>
  export default {
    name: 'OutlinedSelect',

    props: {
      value: {
        required: false,
      },
      label: {
        type: String,
      },
      placeholder: {
        type: String,
        default: '',
      },
      showFocusedPlaceholder: {
        type: Boolean,
        default: false,
      },
      hideRequiredStar: {
        type: Boolean,
        default: false,
      },
      hideLabel: {
        type: Boolean,
        default: false,
      },
      items: {
        type: Array,
        required: true,
      },
    },

    data: () => ({
      model: null,
      isFocused: false,
    }),

    computed: {
      focusedPlaceholder() {
        return this.isFocused && this.showFocusedPlaceholder ? 'Suggestions on typing' : this.placeholder;
      },
    },

    watch: {
      model: {
        handler() {
          this.$emit('input', this.model);
        },
        immediate: true,
      },
    },

    methods: {
      handleFocus() {
        this.isFocused = true;
      },
      handleBlur() {
        this.isFocused = false;
      },
    },
  };
</script>

<template>
  <label>
    <span v-if="!hideLabel" class="white--text label" :class="{ required: !hideRequiredStar }">{{ label }}</span>
    <v-autocomplete
      v-bind="$attrs"
      v-model="model"
      :items="items"
      :placeholder="focusedPlaceholder"
      :menu-props="{ contentClass: 'simple-menu', nudgeBottom: '6px' }"
      label=""
      outlined
      class="mt-1 outlined-input"
      ref="input"
      @focus="handleFocus"
      @blur="handleBlur"
      @change="$emit('change', $event)"
    >
      <template #append>
        <slot name="append"></slot>
      </template>
      <template #append-outer>
        <slot name="append-outer"></slot>
      </template>
      <template #prepend>
        <slot name="prepend"></slot>
      </template>
      <template #prepend-inner>
        <slot name="prepend-inner"></slot>
      </template>
    </v-autocomplete>
  </label>
</template>

<style scoped lang="scss">
  @import '@/scss/mixins.scss';
  @include outlined-input;
</style>
